<div class="guide-page mt-5">
    <div class="guide-shell">

        <!-- Top Level API Mode Selector Bar -->
        <div class="api-mode-bar">
            <div class="mode-tabs">
                <button type="button" class="mode-tab-btn" [class.active]="activeApiMode === 'amz'"
                    (click)="setApiMode('amz')">
                    <i class="fa fa-amazon me-2"></i>
                    <span>AMZ APIs</span>
                    <span class="badge badge-amz ms-2">AMZ</span>
                </button>

                <!-- <button type="button" class="mode-tab-btn" [class.active]="activeApiMode === 'customer'"
                    (click)="setApiMode('customer')">
                    <i class="fa fa-user-shield me-2"></i>
                    <span>Customer APIs</span>
                    <span class="badge badge-customer ms-2">CUSTOMER</span>
                </button> -->
            </div>
            <!-- <div class="mode-actions" *ngIf="activeApiMode === 'customer'">
                <button type="button" class="btn btn-pdf-export" (click)="downloadCustomerApiPdf()">
                    <i class="fa fa-file-pdf me-2"></i> Download Customer API Documentation (PDF)
                </button>
            </div> -->
        </div>

        <!-- ========================================================================================= -->
        <!-- 1. AMAZON APIS VIEW (PRESERVED INTACT) -->
        <!-- ========================================================================================= -->
        <ng-container *ngIf="activeApiMode === 'amz'">
            <aside class="guide-sidebar">
                <div class="sidebar-header">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="sub-title-modern mb-0">Amazon API</span>
                    </div>
                    <h2>Amazon Documentation</h2>
                </div>

                <ul class="section-list">
                    <ng-container *ngFor="let section of sections">
                        <li class="section-item" [class.active]="selectedSection === section.id && !selectedChild"
                            (click)="selectSection(section.id)">
                            <div class="section-meta">
                                <i [class]="section.icon"></i>
                                <span>{{ section.label }}</span>
                            </div>

                            <button *ngIf="section.children?.length" type="button" class="expand-btn"
                                (click)="toggleSection(section.id); $event.stopPropagation()">
                                {{ expandedSection === section.id ? '−' : '+' }}
                            </button>
                        </li>

                        <ul *ngIf="section.children?.length && expandedSection === section.id" class="child-list">
                            <li *ngFor="let child of section.children" class="child-item"
                                [class.active]="selectedSection === section.id && selectedChild === child.id"
                                (click)="selectSection(section.id, child.id); $event.stopPropagation()">
                                {{ child.label }}
                            </li>
                        </ul>
                    </ng-container>
                </ul>
            </aside>

            <section class="guide-content">
                <div class="guide-view-header">
                    <span class="sub-title-modern">Lemonmode Amazon API</span>
                    <h1>{{ selectedSectionLabelWithChild }}</h1>
                    <p class="subtitle">{{ selectedSectionDescription }}</p>
                </div>

                <div class="guide-panel" *ngIf="selectedSection === 'introduction' && selectedChild === 'overview'">
                    <h3>Introduction</h3>
                    <p>
                        Welcome, The purpose of Lemonmode API documentation is to help user understand and make use of
                        API
                        calls to get tracking details for lemonmode tracking number.
                    </p>
                </div>

                <div class="guide-panel"
                    *ngIf="selectedSection === 'introduction' && selectedChild === 'authentication'">
                    <h3>Authentication</h3>
                    <p>
                        Making use of basic authentication, each request must include an authentication header, with a
                        base-64 encoded value. Credentials for basic authentication is provided via mail.
                    </p>
                    <div class="info-callout">
                        <strong>Code Example</strong>
                        <code>'Authorization: Basic [base64(username:password)]'</code>
                    </div>
                </div>

                <div class="guide-panel" *ngIf="selectedSection === 'introduction' && selectedChild === 'throttling'">
                    <h3>Throttling Limit</h3>
                    <p>Throttle limit of API call is 25 hits per min.</p>
                </div>

                <div class="guide-panel" *ngIf="selectedSection === 'apis' && selectedChild === 'tracking-details'">
                    <h3>Get Tracking Details</h3>
                    <p>This call help us to retrieve all tracking details with respect to Lemonmode tracking Id or Order
                        Number.</p>
                    <p><b>Input parameters-</b> Lemonmode Tracking ID/ Order Number.</p>
                    <p><b>Url end point-</b></p>
                    <p><b>Sandbox-</b></p>
                    <p>For Lemonmode Tracking number-</p>
                    <p class="endpoint-link">http://{{ this.url }}/sandbox?tracking_number={{ '{' }}lemon mode tracking
                        number{{ '}' }}</p>
                    <p>For Order number-</p>
                    <p class="endpoint-link">http://{{ this.url }}/sandbox?order_id={{ '{' }}Order number{{ '}' }}</p>
                    <p><b>Production-</b></p>
                    <p>For Lemonmode Tracking number-</p>
                    <p class="endpoint-link">http://{{ this.url }}/operations?tracking_number={{ '{' }}lemon mode
                        tracking
                        number{{ '}' }}</p>
                    <p>For Order number-</p>
                    <p class="endpoint-link">http://{{ this.url }}/operations?order_id={{ '{' }}Order number{{ '}' }}
                    </p>
                    <p><b>Method-</b></p>
                    <p>GET</p>

                    <div class="redoc-state" *ngIf="specLoading">Loading API documentation...</div>
                    <div class="redoc-state redoc-state-error" *ngIf="!specLoading && specLoadError">{{ specLoadError }}
                    </div>
                    <div class="redoc-embed" [class.is-hidden]="specLoading || specLoadError">
                        <div #redocContainer class="redoc-container"></div>
                    </div>
                </div>

                <div class="guide-panel" *ngIf="selectedSection === 'apis' && selectedChild === 'tracking-status'">
                    <h3>Tracking Status Description</h3>
                    <div class="table-wrap">
                        <table class="status-table">
                            <thead>
                                <tr>
                                    <th scope="col">Status</th>
                                    <th scope="col">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>LOC</td>
                                    <td>Order Placed</td>
                                </tr>
                                <tr>
                                    <td>LITU</td>
                                    <td>Order Manifested</td>
                                </tr>
                                <tr>
                                    <td>LRU</td>
                                    <td>Shipment arrived at Hub</td>
                                </tr>
                                <tr>
                                    <td>LTI</td>
                                    <td>In Transit to India</td>
                                </tr>
                                <tr>
                                    <td>LAE</td>
                                    <td>Arrived at Europe Hub</td>
                                </tr>
                                <tr>
                                    <td>LAI</td>
                                    <td>Arrived in India</td>
                                </tr>
                                <tr>
                                    <td>LUC</td>
                                    <td>Under Custom Clearance</td>
                                </tr>
                                <tr>
                                    <td>OP</td>
                                    <td>Dispatched from Mumbai Hub</td>
                                </tr>
                                <tr>
                                    <td>Dispatched</td>
                                    <td>Order Dispatched</td>
                                </tr>
                                <tr>
                                    <td>OT</td>
                                    <td>Order in Transit</td>
                                </tr>
                                <tr>
                                    <td>OO</td>
                                    <td>Order Out for Delivery</td>
                                </tr>
                                <tr>
                                    <td>NDR</td>
                                    <td>Failed Attempt at Delivery</td>
                                </tr>
                                <tr>
                                    <td>DL</td>
                                    <td>Order Delivered</td>
                                </tr>
                                <tr>
                                    <td>RTO</td>
                                    <td>Order Returned Back</td>
                                </tr>
                                <tr>
                                    <td>Booked</td>
                                    <td>Order Booked</td>
                                </tr>
                                <tr>
                                    <td>Manifested</td>
                                    <td>Manifested</td>
                                </tr>
                                <tr>
                                    <td>LOST</td>
                                    <td>LOST</td>
                                </tr>
                                <tr>
                                    <td>Delivered</td>
                                    <td>Delivered</td>
                                </tr>
                                <tr>
                                    <td>Cancelled</td>
                                    <td>Cancelled</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="guide-panel" *ngIf="selectedSection === 'languages' && selectedChild === 'php'">
                    <h3>PHP</h3>
                    <pre><code>&lt;?php
$curl = curl_init();
curl_setopt_array($curl, array(
CURLOPT_URL => 'http://{{this.url}}/operations?tracking_number=1710446256',
CURLOPT_RETURNTRANSFER => true,
CURLOPT_HTTPHEADER => array('Authorization: Basic [base64(username:password)]')
));
$response = curl_exec($curl);
curl_close($curl);
echo $response;
?&gt;</code></pre>
                </div>
            </section>
        </ng-container>

        <!-- ========================================================================================= -->
        <!-- 2. CUSTOMER TRACKING APIS VIEW (NEW & DYNAMIC) -->
        <!-- ========================================================================================= -->
        <ng-container *ngIf="activeApiMode === 'customer'">
            <aside class="guide-sidebar">
                <div class="sidebar-header">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="sub-title-modern mb-0">Customer API</span>
                    </div>
                    <h2>Customer Tracking Docs</h2>
                </div>

                <ul class="section-list">
                    <ng-container *ngFor="let section of customerSections">
                        <li class="section-item"
                            [class.active]="selectedCustomerSection === section.id && !selectedCustomerChild"
                            (click)="selectCustomerSection(section.id)">
                            <div class="section-meta">
                                <i [class]="section.icon"></i>
                                <span>{{ section.label }}</span>
                            </div>

                            <button *ngIf="section.children?.length" type="button" class="expand-btn"
                                (click)="toggleCustomerSection(section.id); $event.stopPropagation()">
                                {{ expandedCustomerSection === section.id ? '−' : '+' }}
                            </button>
                        </li>

                        <ul *ngIf="section.children?.length && expandedCustomerSection === section.id"
                            class="child-list">
                            <li *ngFor="let child of section.children" class="child-item"
                                [class.active]="selectedCustomerSection === section.id && selectedCustomerChild === child.id"
                                (click)="selectCustomerSection(section.id, child.id); $event.stopPropagation()">
                                {{ child.label }}
                            </li>
                        </ul>
                    </ng-container>
                </ul>
            </aside>

            <section class="guide-content">
                <div class="guide-view-header">
                    <span class="sub-title-modern">Customer Tracking API</span>
                    <h1>{{ selectedCustomerSectionLabelWithChild }}</h1>
                    <p class="subtitle">{{ selectedCustomerSectionDescription }}</p>
                </div>

                <!-- OVERVIEW & ARCHITECTURE -->
                <div class="guide-panel"
                    *ngIf="selectedCustomerSection === 'customer-intro' && selectedCustomerChild === 'overview-auth'">
                    <h3>Customer Tracking API Overview</h3>
                    <p>
                        The Lemonmode Customer Tracking API provides Machine-to-Machine (M2M) integration for generating
                        tracking numbers,
                        storing order items, updating last-mile carrier tracking, and retrieving real-time shipment
                        status timeline logs.
                    </p>
                    <div class="info-callout border-primary bg-light p-3 rounded-3">
                        <h6 class="fw-bold mb-2 text-dark"><i class="fa fa-lock text-primary me-2"></i> Security &
                            Isolation Architecture</h6>
                        <ul class="mb-0 small text-dark">
                            <li><strong>Customer Isolation:</strong> All orders, tracking numbers, and API credentials
                                are strictly bound to the authenticated customer ID.</li>
                            <li><strong>camelCase Payload Standard:</strong> All request and response field names
                                strictly use <code>camelCase</code>.</li>
                            <li><strong>Order Number Prefixing:</strong> Order numbers are prepended with the customer's
                                4-character ID suffix (e.g. <code>9011-1001</code>).</li>
                            <li><strong>Replay Protection:</strong> Requests require a unique <code>X-Request-ID</code>
                                and <code>X-Timestamp</code> evaluated within a strict ±5-minute window.</li>
                        </ul>
                    </div>
                </div>

                <!-- M2M OAUTH TOKENS -->
                <div class="guide-panel"
                    *ngIf="selectedCustomerSection === 'customer-intro' && selectedCustomerChild === 'oauth-flow'">
                    <h3>Machine-to-Machine (M2M) OAuth Tokens</h3>
                    <p>Customer Tracking APIs require a valid Bearer access token obtained via Client Credentials grant
                        type.</p>

                    <h5 class="mt-4 fw-bold"><span class="badge-post me-2">POST</span> /v1/tracking/auth/token</h5>
                    <p class="small text-muted">Exchange Client ID & Client Secret for a 1-hour access token and refresh
                        token.</p>

                    <label class="fw-semibold small text-muted">Request Body (JSON):</label>
                    <pre><code>{{ '{' }}
  "client_id": "LEMONMODE_ABC12345",
  "client_secret": "YOUR_CLIENT_SECRET",
  "grant_type": "client_credentials"
{{ '}' }}</code></pre>

                    <label class="fw-semibold small text-muted mt-3">Success Response (200 OK):</label>
                    <pre><code>{{ '{' }}
  "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6...",
  "refresh_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6...",
  "token_type": "Bearer",
  "expires_in": 3600
{{ '}' }}</code></pre>
                </div>

                <!-- HMAC SIGNING SPECS -->
                <div class="guide-panel"
                    *ngIf="selectedCustomerSection === 'customer-intro' && selectedCustomerChild === 'hmac-signing'">
                    <h3>HMAC-SHA256 Request Signing Specification</h3>
                    <p>Every protected API call under <code>/v1/tracking/*</code> must include the following HTTP
                        headers:</p>

                    <div class="table-wrap mb-4">
                        <table class="status-table">
                            <thead>
                                <tr>
                                    <th>Header Name</th>
                                    <th>Description</th>
                                    <th>Example</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><code>Authorization</code></td>
                                    <td>Bearer OAuth access token</td>
                                    <td><code>Bearer eyJhbGci...</code></td>
                                </tr>
                                <tr>
                                    <td><code>X-Client-ID</code></td>
                                    <td>Your Customer API Client ID</td>
                                    <td><code>LEMONMODE_ABC12345</code></td>
                                </tr>
                                <tr>
                                    <td><code>X-Timestamp</code></td>
                                    <td>ISO 8601 UTC timestamp (±5 min)</td>
                                    <td><code>2026-08-17T13:00:00.000Z</code></td>
                                </tr>
                                <tr>
                                    <td><code>X-Request-ID</code></td>
                                    <td>Unique request ID (Replay protection)</td>
                                    <td><code>req-1700000000000</code></td>
                                </tr>
                                <tr>
                                    <td><code>X-Signature</code></td>
                                    <td>HMAC-SHA256 Hex signature</td>
                                    <td><code>a8f9c1023b49ef...</code></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <h5 class="fw-bold mb-2">Canonical String Calculation:</h5>
                    <pre><code>CANONICAL_STRING = HTTP_METHOD + REQUEST_PATH + TIMESTAMP + REQUEST_BODY</code></pre>
                    <p class="small text-muted mt-2">Example:
                        <code>POST/v1/tracking/generate-tracking-number2026-08-17T13:00:00.000Z{{ '{' }}"orderNumber":"1001","orderItemId":"ITEM1001"{{ '}' }}</code>
                    </p>
                </div>

                <!-- CREDENTIALS MANAGEMENT -->
                <div class="guide-panel"
                    *ngIf="selectedCustomerSection === 'customer-intro' && selectedCustomerChild === 'credential-mgmt'">
                    <h3>Credentials Management APIs</h3>
                    <p>Manage Client ID & Client Secret credentials from the Customer Portal.</p>

                    <ul class="list-group list-group-flush mb-3">
                        <li class="list-group-item"><strong>Issue Credentials:</strong>
                            <code>POST /v1/customer/tracking-api/credentials</code>
                        </li>
                        <li class="list-group-item"><strong>Rotate Secret:</strong>
                            <code>POST /v1/customer/tracking-api/credentials/rotate</code>
                        </li>
                        <li class="list-group-item"><strong>Revoke Credentials:</strong>
                            <code>POST /v1/customer/tracking-api/credentials/revoke</code>
                        </li>
                        <li class="list-group-item"><strong>Check Status:</strong>
                            <code>GET /v1/customer/tracking-api/credentials/status</code>
                        </li>
                    </ul>
                </div>

                <!-- REDOC CUSTOMER OPENAPI SPECIFICATION -->
                <div class="guide-panel"
                    *ngIf="selectedCustomerSection === 'customer-endpoints' && selectedCustomerChild === 'customer-redoc-view'">
                    <h3>Customer Tracking API Specification (OpenAPI 3.0)</h3>
                    <p>Interactive API reference for all Customer Tracking endpoints, security parameters, camelCase
                        payload schemas, and response status codes.</p>

                    <div class="redoc-state" *ngIf="customerSpecLoading">Loading Customer API documentation...</div>
                    <div class="redoc-state redoc-state-error" *ngIf="!customerSpecLoading && customerSpecLoadError">{{
                        customerSpecLoadError }}</div>
                    <div class="redoc-embed" [class.is-hidden]="customerSpecLoading || customerSpecLoadError">
                        <div #customerRedocContainer class="redoc-container"></div>
                    </div>
                </div>

                <!-- DYNAMIC MARKETPLACE FLOW STATUS VIEWER -->
                <div class="guide-panel"
                    *ngIf="selectedCustomerSection === 'marketplace-flow-sec' && selectedCustomerChild === 'flow-status-viewer'">
                    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                        <h3>Dynamic Marketplace Flow Status Viewer</h3>

                        <div class="d-flex align-items-center gap-2">
                            <label class="fw-bold small text-muted mb-0">Select Flow:</label>
                            <select class="form-select form-select-sm font-monospace fw-bold border-primary"
                                [(ngModel)]="selectedFlowCode">
                                <option *ngFor="let flow of marketplaceFlows" [value]="flow.flowCode">
                                    {{ flow.flowCode }} - {{ flow.flowName }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <p class="text-muted small mb-4">
                        Shipment statuses are evaluated dynamically based on the active Marketplace Flow configuration.
                        Below are the live status mappings for <strong>{{ currentFlow.flowName }}</strong> ({{
                        currentFlow.sourceCountry }} → {{ currentFlow.destinationCountry }}):
                    </p>

                    <div class="table-wrap">
                        <table class="status-table">
                            <thead>
                                <tr>
                                    <th>Index</th>
                                    <th>Event Code</th>
                                    <th>Shipment Status</th>
                                    <th>Amazon Code</th>
                                    <th>Amazon Status</th>
                                    <th>Location</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of currentFlow.statuses">
                                    <td><span class="badge bg-secondary">{{ item.status_index }}</span></td>
                                    <td><code>{{ item.event_code }}</code></td>
                                    <td><strong class="text-dark">{{ item.shipment_status }}</strong></td>
                                    <td><code>{{ item.amazon_event_code || '-' }}</code></td>
                                    <td>{{ item.amazon_shipment_status }}</td>
                                    <td><span class="small text-muted">{{ item.city }}, {{ item.state }} ({{
                                            item.countrycode }})</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </ng-container>

    </div>
</div>